// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/appveyor/projects/domiz-io/src/pages/404.js"),
  "component---src-pages-cotb-2018-js": require("gatsby-module-loader?name=component---src-pages-cotb-2018-js!/home/appveyor/projects/domiz-io/src/pages/cotb2018.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/appveyor/projects/domiz-io/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/appveyor/projects/domiz-io/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/appveyor/projects/domiz-io/.cache/json/404.json"),
  "cotb-2018.json": require("gatsby-module-loader?name=path---cotb-2018!/home/appveyor/projects/domiz-io/.cache/json/cotb-2018.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/appveyor/projects/domiz-io/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/appveyor/projects/domiz-io/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/home/appveyor/projects/domiz-io/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js